import { type ISubmitApplicationProcessPayload } from 'src/types/leaveApplications/types';

export const dumpSubmitApplicationProcess = (vacationId: number, processName: string): ISubmitApplicationProcessPayload => {
  return {
    id: vacationId,
    processName
  };
};
